
import universal, { setHasBabelPlugin } from '/opt/build/repo/node_modules/react-universal-component/dist/index.js'


setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

const t_0 = universal(import('../node_modules/react-static/lib/browser/components/Default404'), universalOptions)
const t_1 = universal(import('../src/containers/home/home'), universalOptions)
const t_2 = universal(import('../src/containers/cart/cart'), universalOptions)
const t_3 = universal(import('../src/containers/products/products'), universalOptions)
const t_4 = universal(import('../src/containers/product/productRoute'), universalOptions)
const t_5 = universal(import('../src/containers/about/about'), universalOptions)
const t_6 = universal(import('../src/containers/projects/projectsRoute'), universalOptions)
const t_7 = universal(import('../src/containers/project/projectRoute'), universalOptions)


// Template Map
export default {
  '../node_modules/react-static/lib/browser/components/Default404': t_0,
'../src/containers/home/home': t_1,
'../src/containers/cart/cart': t_2,
'../src/containers/products/products': t_3,
'../src/containers/product/productRoute': t_4,
'../src/containers/about/about': t_5,
'../src/containers/projects/projectsRoute': t_6,
'../src/containers/project/projectRoute': t_7
}

export const notFoundTemplate = "../node_modules/react-static/lib/browser/components/Default404"
